import React from "react";
import FlxdeckHeader from "./FlxdeckHeader";
import "./style.css";
import WorkoutDetails from "../../common/WorkoutDetails/WorkoutDetails.js";

const FlxdeckWorkoutDetails = () => {
  return (
    <div className="flxdeck">
      <FlxdeckHeader />
      <WorkoutDetails />
    </div>
  );
};

export default FlxdeckWorkoutDetails;
